import { SerializedStyles } from "@emotion/react";
import { Ref, memo, useCallback } from "react";
import { usePartialSubmit } from "src/apps/AppFlow/pages/hooks";
import { FormFlowPage } from "src/components";
import DropdownSelector from "src/components/DropdownSelector";

import { formatters } from "@fraction/shared";

export interface NumberOfApplicantsProps {
  onChange: (value: number) => void;
  value?: number;

  focusRef?: Ref<HTMLInputElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const NumberOfApplicants = ({
  onNext,
  onBack,
  style,
  focusRef,
  value,
  onChange,
  ...props
}: NumberOfApplicantsProps) => {
  const validate = useCallback(() => !!value, [value]);
  const { handleNext, nextDisabled, nextLoading } = usePartialSubmit({ onNext, validate });

  const handleChange = useCallback(
    (val: string) => {
      onChange?.(formatters.number.toNumber(val));
    },
    [onChange]
  );

  return (
    <FormFlowPage
      {...props}
      title="How many people are on your application?"
      description="You should include everyone that's on title. If you are married, it's also helpful to include your spouse."
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
      nextLoading={nextLoading}
    >
      <DropdownSelector
        focusRef={focusRef}
        value={value?.toString()}
        label="Number of applicants"
        onChange={handleChange}
        options={[
          { value: "1", label: "One" },
          { value: "2", label: "Two" },
          { value: "3", label: "Three" },
          { value: "4", label: "Four" },
          { value: "5", label: "Five" },
          { value: "6", label: "Six" },
        ]}
      />
    </FormFlowPage>
  );
};

export default memo(NumberOfApplicants);
